import { initialPageLoadSpan } from '@/lib/sentry/init';
import * as Sentry from '@sentry/react';

// Create a context for the span
import { createContext, useRef } from 'react';

export const SentrySpanContext = createContext<React.RefObject<Sentry.Span | undefined> | null>(
  null,
);

export const SentryProvider = ({ children }: { children: React.ReactNode }) => {
  const pageLoadSpanRef = useRef<Sentry.Span | undefined>(initialPageLoadSpan);

  const SentryWithProfiler = Sentry.withProfiler(() => (
    <SentrySpanContext.Provider value={pageLoadSpanRef}>{children}</SentrySpanContext.Provider>
  ));

  return <SentryWithProfiler />;
};
